var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        disabled: _vm.isTooltipDisabled,
        effect: "dark",
        content: _vm.inputVal,
        placement: "top",
      },
    },
    [
      _c(
        "el-input",
        _vm._b(
          {
            staticClass: "my-input",
            class: { isView: _vm.mode !== "edit" },
            attrs: {
              value: _vm.inputVal,
              "show-word-limit": _vm.showWordLimit,
              placeholder: _vm.placeholderTxt,
              clearable: "",
              autocomplete: "off",
              disabled: _vm.isDisabled,
            },
            on: { input: _vm.onInput },
          },
          "el-input",
          _vm.$attrs,
          false
        ),
        [_c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }